import React from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { renderSalePrice } from 'js/helpers/UndisclosedSalesHelper';
import MUITooltip from 'js/components/common/MUITooltip';

const UndisclosedSales = ({
    soldDate = '',
    saleType,
    salePrice,
    isTimeline,
    isExactPrice,
    isAgentsAdvice,
    tooltipPosition,
    isPriceWithheld,
    undisclosedSalesAccess,
    undisclosedSalesFeature,
    noPriceAvailableText,
    noPriceAndDateAvailableText,
    undisclosedText = 'Not Disclosed',
    isPrintPage,
}) => (
    <span className="undisclosed-sales--container">
        <span className="sale-price">
            {renderSalePrice({
                saleType,
                soldDate,
                salePrice,
                isTimeline,
                isExactPrice,
                isAgentsAdvice,
                isPriceWithheld,
                noPriceAvailableText,
                undisclosedSalesAccess,
                undisclosedSalesFeature,
                noPriceAndDateAvailableText,
                undisclosedText,
            })}
        </span>
        {
            isPriceWithheld && undisclosedSalesAccess && !undisclosedSalesFeature &&
            <span>
                <sup>Un</sup>
                {
                    !isPrintPage &&
                    <MUITooltip
                        title="This sale price is classified
                                as 'undisclosed' and is available for
                                viewing by Real Estate Agents and Valuers only.
                                Sharing this price outside
                                the RP Data platform is prohibited."
                        placement={tooltipPosition || 'right'}
                        arrow
                        PopperProps={{
                            sx: { zIndex: 9999 }
                        }}
                    >
                        <InfoOutlinedIcon sx={{
                            width: '16px',
                            height: '16px',
                            marginLeft: '4px',
                            cursor: 'pointer',
                        }}/>
                    </MUITooltip>
                }
            </span>
        }
    </span>
);

/**
 * tooltipPosition: tooltip displaying position
 * isTimeline: will not display "Last" from "Last {sold, transacted, transferred}"
 * isExactPrice: Display price and tool tip only.
 * noPriceAvailableText: Display text when price is not available, default value is Dash.
 * noPriceAndDateAvailableText: Display text when sale detail is not available,
 *   default value is Dash.
 */

UndisclosedSales.propTypes = {
    tooltipPosition: PropTypes.string,
    soldDate: PropTypes.string,
    saleType: PropTypes.string,
    salePrice: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    isTimeline: PropTypes.bool,
    isPriceWithheld: PropTypes.bool,
    undisclosedSalesAccess: PropTypes.bool,
    isAgentsAdvice: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    isExactPrice: PropTypes.bool,
    undisclosedSalesFeature: PropTypes.bool,
    noPriceAvailableText: PropTypes.string,
    noPriceAndDateAvailableText: PropTypes.string,
    undisclosedText: PropTypes.string,
    isPrintPage: PropTypes.bool,
};

export default UndisclosedSales;
